import { render, staticRenderFns } from "./BuildHelperStatements.vue?vue&type=template&id=4ca7cd06&scoped=true"
import script from "./BuildHelperStatements.vue?vue&type=script&lang=js"
export * from "./BuildHelperStatements.vue?vue&type=script&lang=js"
import style0 from "./BuildHelperStatements.vue?vue&type=style&index=0&id=4ca7cd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7cd06",
  null
  
)

export default component.exports